import React from 'react';
import FlatButton from '../../../../tc-ui/flat-button-with-loader';
import StepperActions from '../../../generic-components/stepper-actions';
import TypeControlledTextField from '../../../../tc-ui/type-controlled-textfield.jsx';
import TwoColumnRow from '../../../../tc-ui/two-column-row.jsx';
import AccomRateForm from '../../../generic-components/rate-forms/accom-rates-form.jsx';
import NonAccomRateForm from '../../../generic-components/rate-forms/non-accommo-rates-form-templates/non-accom-rates-form.jsx';
import RateTable from '../../../generic-components/rate-tables/rate-table-template-container';
import { isEmpty, any, or } from 'ramda';
import { RadioButton } from 'material-ui';
import { getIn } from '../../../../../utils/functional';
import Select from 'react-select';

const checkIfShouldDisable = (data, offerRates, productType) => {
  const checkDiscountRate = data.rate === 'discount' ? Boolean(data.discountType && data.amount) : true;
  const checkRateAmount = () => {
    if (data.rate === 'rateAmount') {
      if (data.rates && data.rates.length) {
        if (data.rates.every(rate => rate.notApplicable)) return true;
      } else {
        if (productType === 'Non-Accommodation') {
          const standardIsEmpty = isEmpty(getIn(['nonAccomStandard', 'nett'], offerRates), getIn(['nonAccomStandard', 'retail'], offerRates));
          const multiDayTourIsEmpty = !any(value => value)([
            offerRates.baseRate,
            or(offerRates.rateType === 'includeCommission' && offerRates.retailRate, offerRates.rateType === 'nett'),
            offerRates.singleSupplement,
            offerRates.maxAdults,
          ]);
          const transfersOrPriceBreakIsEmpty = (() => {
            const checkForSingleDetail = detail => {
              return detail.maxAdultsPlusChild && detail.baseRate && (offerRates.rateType === 'includeCommission' ? detail.retailRate : true);
            };
            const filteredArray = (offerRates.transfersOrPriceBreak || []).filter(checkForSingleDetail);
            return !Boolean(filteredArray.length);
          })();
          return !(standardIsEmpty && multiDayTourIsEmpty && transfersOrPriceBreakIsEmpty);
        }
        if (productType === 'Accommodation') {
          if (offerRates.rateType === 'nett') return Boolean(offerRates.baseRate && offerRates.additionalAdult && offerRates.additionalChild && offerRates.includedGuestsinBaseRate && offerRates.maxAdults && offerRates.maxAdultsChildren);
          if (offerRates.rateType === 'includeCommission') return Boolean(offerRates.retailRate && offerRates.additionalAdult && offerRates.additionalChild && offerRates.includedGuestsinBaseRate && offerRates.maxAdults && offerRates.maxAdultsChildren);
        }
      }
    }
    return true;
  };
  return !Boolean(
    (data.rate || data.isStayPay) &&
    checkDiscountRate &&
    checkRateAmount()
  );
};

const StepTwo = ({
  data,
  onRequestClose,
  onTextFieldChangeWithKeyPath,
  updateFieldForOfferRates,
  updateFieldWithKeyPathForOfferRates,
  calculateAccomRatesTable,
  calculateStandardNonAccomRatesTable,
  goToStep,
  productType,
  offerRates,
  updateTableCell,
  updateFormData,
  }) => {
  const shouldDisable = checkIfShouldDisable(data, offerRates, productType);
  const RateForm = productType === 'Accommodation' ? AccomRateForm : NonAccomRateForm;
  const continueFunc = productType === 'Accommodation' ? calculateAccomRatesTable : calculateStandardNonAccomRatesTable;
  return (
    <div style={{ padding: '36px', paddingTop: '8px', fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif" }}>
      {
        Boolean(data.isStayPay) ? (
          <div style={{ marginBottom: '24px' }}>
            <div style={{ paddingTop: '16px', marginBottom: '8px', color: 'rgba(0, 0, 0, 0.74)' }}>Do your season rates apply to your Stay Pay Offer </div>
            <RadioButton
              checked={!data.rate}
              label="Yes"
              onCheck={() => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'rate'], value: null })}
              labelStyle={{ color: !data.rate ? 'rgba(0, 0, 0, 0.74)' : 'grey' }}
            />
            <RadioButton
              checked={data.rate === 'rateAmount'}
              label={`No, I'd like to enter a different rate for the Stay Pay offer`}
              onCheck={() => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'rate'], value: 'rateAmount' })}
              labelStyle={{ color: data.rate === 'rateAmount' ? 'rgba(0, 0, 0, 0.74)' : 'grey' }}
            />
          </div>
        ) : (
          <div style={{ minHeight: '180px' }}>
            <TwoColumnRow
              outerContainerStyle={{ height: '72px', marginBottom: '0', overflow: 'inherit' }}
              leftColumnStyle={{ position: 'relative', top: '34px', width: '40%' }}
              leftColumnContent="Offer type"
              rightColumnStyle={{ width: '60%' }}
              rightColumnContent={<div style={{ width: '100%', height: '72px' }}>
                <div style={{ width: '45%', display: 'inline-block', top: data.offerType === 'Per number of guests' ? '10px' : '34px', position: 'relative' }}>
                  <Select
                    name="offerType"
                    options={[
                      { value: 'Per night', label: 'Per night' },
                      { value: 'Per package', label: 'Per package' },
                      { value: 'Per person', label: 'Per person' },
                      { value: 'Per number of guests', label: 'Per number of guests' },
                    ]}
                    value={data.offerType}
                    onChange={({ value }) => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'offerType'], value })}
                    placeholder="Offer Type"
                    clearable={false}
                    scrollMenuIntoView={false}
                  />
                </div>
                {
                  data.offerType === 'Per number of guests' ?
                    <TypeControlledTextField
                      floatingLabelText="Number"
                      controlledType="number"
                      value={data.numberOfGuests}
                      onChange={({ target: { value } }) => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'numberOfGuests'], value })}
                      style={{ width: '45%', display: 'inline-block', marginLeft: '5%', position: 'relative' }}
                    /> : undefined
                }
              </div>}
            />
            <TwoColumnRow
              outerContainerStyle={{ height: '72px', overflow: 'inherit', clear: 'both' }}
              leftColumnStyle={{ width: '40%' }}
              leftColumnContent={<div style={{ padding: '20px 0 4px 0' }}>
                Offer rate
                <div style={{ color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' }}>
                  * Required
                </div>
              </div>}
              rightColumnStyle={{ width: '60%' }}
              rightColumnContent={<div style={{ width: '100%', height: '72px' }}>
                <div style={{ width: '35%', float: 'left', padding: data.rate === 'discount' ? '30px 0 4px 0' : '20px 0 4px 0' }}>
                  <Select
                    name="rate"
                    options={[
                      { value: 'freeOfCharge', label: 'Free of charge' },
                      data.isStayPay ? null : { value: 'discount', label: 'Discount' },
                      { value: 'rateAmount', label: 'Rate Amount' },
                    ].filter(x => x)}
                    value={data.rate}
                    onChange={({ value }) => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'rate'], value })}
                    placeholder="Rate"
                    clearable={false}
                    scrollMenuIntoView={false}
                  />
                </div>
                {
                  data.rate === 'discount' ?
                    <div style={{ width: '28%', marginLeft: '5%', padding: data.rate === 'discount' ? '30px 0 4px 0' : '20px 0 4px 0', display: 'inline-block' }}>
                      <Select
                        name="rate"
                        options={[
                          { value: 'percentage', label: 'Percentage' },
                          { value: 'flatRate', label: 'Flat fee' },
                        ]}
                        value={data.discountType}
                        onChange={({ value }) => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'discountType'], value })}
                        placeholder="Discount Type"
                        clearable={false}
                        scrollMenuIntoView={false}
                      />
                    </div> :
                    undefined
                }
                {
                  data.rate === 'discount' ? <div style={{ width: '28%', float: 'right', display: 'inline-block' }}>
                    <TypeControlledTextField
                      floatingLabelText="Amount" style={{ display: 'inline-block', width: '70%' }}
                      value={data.amount}
                      controlledType="number"
                      onChange={({ target: { value } }) => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'amount'], value })}
                    />
                    <span style={{ lineHeight: '48px', fontSize: '16px' }}>{data.discountType === 'percentage' ? '%' : '$'}</span>
                  </div> : undefined
                }
              </div>}
            />
          </div>
        )
      }
      {
        (() => {
          if (data.rate === 'rateAmount') {
            if (data.rates && data.rates.length) {
              return (
                <RateTable
                  productType={productType}
                  withEditableCell
                  rateSet={{ rates: data.rates, nonStandardTemplateType: data.nonStandardTemplateType }}
                  updateTableCell={updateTableCell}
                  forOffer
                  showHeader
                />
              );
            }
            return (
              <RateForm
                {...offerRates}
                showTaxCurrency={false}
                updateFormData={updateFormData}
                updateFieldWithKeyPath={updateFieldWithKeyPathForOfferRates}
                updateFieldValue={updateFieldForOfferRates}
              />
            );
          }
        })()
      }
      <StepperActions
        style={{ clear: 'both', top: '12px', position: 'relative' }}
        showBackButton
        backButtonFunc={() => goToStep({ stepperWizardName: 'specialOffersStepper', componentIndex: 0 })}
        rightButtons={
      <div>
        <FlatButton
          secondary
          label={data.rate === 'rateAmount' ? 'Generate Rate Table' : 'Continue'}
          onTouchTap={() => {
            if (!(data.rates && data.rates.length) && data.rate === 'rateAmount') continueFunc();
            goToStep({ stepperWizardName: 'specialOffersStepper', componentIndex: 2 });
          }}
          labelStyle={{ fontWeight: '600' }}
          disabled={shouldDisable}
        />
      </div>
      }
      />
    </div>
  );
};

export default StepTwo;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/special-offers/2-step-offers.jsx